import React from "react";
import callIcon01 from "../../assets/img/call-icon01.png";
import callIcon02 from "../../assets/img/call-icon02.png";
import callIcon03 from "../../assets/img/call-icon03.png";

function CallWipia(props) {


    return (

				<section className="callWipia bg-blue">
					<div className="container-auto sec-py">
						<p className="contact">CONTACT US</p>
						<h4 className="title">위피아의 전문가에게 직접 문의해보세요.</h4>
						<ul className="list">
							<li>
								<img src={callIcon01} alt="Call Us" className="call-icon" />
								<div className="textBox">
									<p className="tit">Call Us</p>
									<p className="txt">02)2038-8311</p>
								</div>
							</li>
							<li>
								<img src={callIcon02} alt="FAX" className="call-icon" />
								<div className="textBox">
									<p className="tit">FAX</p>
									<p className="txt">02)2038-8322</p>
								</div>
							</li>
							<li>
								<img src={callIcon03} alt="Email" className="call-icon" />
								<div className="textBox">
									<p className="tit">Email</p>
									<p className="txt">info@wipia.co.kr</p>
								</div>
							</li>
						</ul>
					</div>
				</section>
        
    )
}


export default CallWipia;